/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarket,
    BrandAndMarketFromJSON,
    BrandAndMarketFromJSONTyped,
    BrandAndMarketToJSON,
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface TTLOListConfiguration
 */
export interface TTLOListConfiguration {
    /**
     * 
     * @type {Array<BrandAndMarket>}
     * @memberof TTLOListConfiguration
     */
    allowedBrandsAndMarkets?: Array<BrandAndMarket> | null;
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof TTLOListConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof TTLOListConfiguration
     */
    readonly distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof TTLOListConfiguration
     */
    readonly relevance?: Array<number> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof TTLOListConfiguration
     */
    readonly providers?: Array<GuidIdAndLabel> | null;
}

export function TTLOListConfigurationFromJSON(json: any): TTLOListConfiguration {
    return TTLOListConfigurationFromJSONTyped(json, false);
}

export function TTLOListConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TTLOListConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedBrandsAndMarkets': !exists(json, 'allowedBrandsAndMarkets') ? undefined : (json['allowedBrandsAndMarkets'] === null ? null : (json['allowedBrandsAndMarkets'] as Array<any>).map(BrandAndMarketFromJSON)),
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function TTLOListConfigurationToJSON(value?: TTLOListConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedBrandsAndMarkets': value.allowedBrandsAndMarkets === undefined ? undefined : (value.allowedBrandsAndMarkets === null ? null : (value.allowedBrandsAndMarkets as Array<any>).map(BrandAndMarketToJSON)),
    };
}


